import clsx from 'clsx';
import type { InputHTMLAttributes, ReactNode } from 'react';

import styles from './Toggle.module.scss';

type ToggleProps = {
  children?: ReactNode;
  labelOn?: ReactNode;
  labelOff?: ReactNode;
  variant?: 'default' | 'danger' | 'warning';
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const Toggle = ({
  children,
  labelOn,
  labelOff,
  variant = 'default',
  className,
  id,
  checked,
  ...props
}: ToggleProps) => {
  const toggleId = id || `toggle-toggle`;
  const displayLabel = children ?? (checked ? labelOn : labelOff);

  return (
    <label
      htmlFor={toggleId}
      className={clsx(
        styles.toggleWrapper,
        checked && variant === 'danger' && styles.danger,
        checked && variant === 'warning' && styles.warning,
        className,
      )}
    >
      <span className={styles.label}>{displayLabel}</span>
      <input type="checkbox" id={toggleId} className={styles.input} checked={checked} {...props} />
      <span className={styles.slider} />
    </label>
  );
};

export default Toggle;
